import { isTerminalOrderStatus, ORDER_STATUS } from '@/entities/order/model/orderStatus'

export function isCourierOrderFinished(order) {
  if (!order) {
    return true
  }
  return isTerminalOrderStatus(order.status) || Boolean(order.deliveredAt)
}

export function isCourierAwaitingOrderAcceptance(order) {
  if (!order?.status || isTerminalOrderStatus(order.status) || order.pickedUpAt) {
    return false
  }
  return !order.acceptedAt
}

export function isCourierOnActiveDelivery(order) {
  if (!order?.status || isTerminalOrderStatus(order.status) || order.deliveredAt) {
    return false
  }
  if (order.status === ORDER_STATUS.PICKED_UP || order.pickedUpAt) {
    return true
  }
  return Boolean(order.acceptedAt)
}

export function isCourierDeliveringToClient(order) {
  if (!order?.status || isTerminalOrderStatus(order.status) || order.deliveredAt) {
    return false
  }
  return (
    order.status === ORDER_STATUS.PICKED_UP ||
    order.status === ORDER_STATUS.ON_THE_WAY ||
    Boolean(order.pickedUpAt)
  )
}

export function buildCourierOrderUi(order) {
  const awaitingAccept = isCourierAwaitingOrderAcceptance(order)
  const deliveringToClient = isCourierDeliveringToClient(order)

  return {
    showAccept: awaitingAccept,
    showReject: awaitingAccept,
    showPickUp: Boolean(order?.acceptedAt) && !order?.pickedUpAt && !isTerminalOrderStatus(order?.status),
    showDeliver: deliveringToClient,
    awaitingAccept,
    deliveringToClient,
  }
}
